export default __webpack_public_path__ + "static/media/digitizeCircle.0c40decd.cur";